import { getBrandConfig as parseBrandConfig, type BrandConfig } from '@erp/shared';

import brandJson from '../../../../brand/brand.config.json';

/**
 * Build-time resolved brand config. Vite bakes /brand/brand.config.json into the bundle
 * via a static JSON import. Code that needs brand metadata calls getBrand() — which
 * passes the imported JSON through Zod validation and returns a typed BrandConfig.
 */
let cached: BrandConfig | undefined;

export function getBrand(): BrandConfig {
  if (cached) return cached;
  cached = parseBrandConfig(brandJson);
  return cached;
}

/** Helper: derive a sibling logo path from the brand mark path. */
export function brandLogoPath(name: string): string {
  const cfg = getBrand();
  const dir = cfg.mark.replace(/\/[^/]+$/, '');
  return `${dir}/${name}`;
}
